import type { UserLifecycleAction } from "../../api/admin-user-lifecycle";
import type { UserStatus } from "../../api/admin-users";
import { t } from "../../i18n";
import { s } from "./user-detail-styles";

export type UserAction = "freeze" | "unfreeze" | UserLifecycleAction;

export function UserActionButtons({
  status,
  onAction,
}: {
  status: UserStatus;
  onAction: (action: UserAction) => void;
}): React.JSX.Element {
  if (status === "deactivated") {
    return (
      <span style={s.deactivatedLabel}>{t("user_detail.deactivated")}</span>
    );
  }

  return (
    <div style={s.actionGroup}>
      <ActionButton
        label={t("user_detail.issue_warning")}
        style={s.warningBtn}
        onClick={() => onAction("issue-warning")}
      />
      {status === "active" ? (
        <ActionButton
          label={t("user_detail.freeze_account")}
          style={s.dangerBtn}
          onClick={() => onAction("freeze")}
        />
      ) : (
        <ActionButton
          label={t("user_detail.unfreeze_account")}
          style={s.primaryBtn}
          onClick={() => onAction("unfreeze")}
        />
      )}
      <ActionButton
        label={t("user_detail.suspend_account")}
        style={s.dangerBtn}
        onClick={() => onAction("suspend")}
      />
      <ActionButton
        label={t("user_detail.deactivate_account")}
        style={s.dangerBtn}
        onClick={() => onAction("deactivate")}
      />
      <ActionButton
        label={t("user_detail.terminate_account")}
        style={s.dangerBtn}
        onClick={() => onAction("terminate")}
      />
    </div>
  );
}

function ActionButton({
  label,
  style,
  onClick,
}: {
  label: string;
  style: React.CSSProperties;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <button type="button" style={style} onClick={onClick}>
      {label}
    </button>
  );
}
